import { getRequest, putRequest } from "~/apis/requests/useApiCall";
import { Notification } from "~/types/notification";
import { NotificationStatus } from "~/types/enums/notificationStatus";

function formatDate(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

function subtractDays(date: Date, days: number): Date {
  const result = new Date(date);
  result.setDate(result.getDate() - days);
  return result;
}

export const useNotificationStore = definePiniaStore("notificationStore", {
  state: () => ({
    notifications: [] as Notification[],
    loading: false,
    from: formatDate(subtractDays(new Date(), 1)),
    to: formatDate(new Date()),
    moreCommentsLoader: false,
  }),
  actions: {
    async getNotifications(params: any) {
      this.loading = true;
      let url = `notifications?`;
      for (const key in params) {
        url += `${key}=${params[key]}&`;
      }
      url = url.slice(0, -1);
      const { response, error } = await getRequest<Notification[]>(url);
      if (!error) {
        this.notifications = response.data;
      }
      this.loading = false;
    },
    async showMoreNotifications(params: any) {
      this.moreCommentsLoader = true;
      if (this.notifications.length > 0) {
        params.oldest_id = this.notifications[this.notifications.length - 1].id;
      }
      let url = `notifications?`;
      for (const key in params) {
        url += `${key}=${params[key]}&`;
      }
      url = url.slice(0, -1);
      const { response, error } = await getRequest<Notification[]>(url);
      if (!error) {
        this.notifications.push(...response.data);
      }
      this.moreCommentsLoader = false;
    },
    async updateNotification(notificationId: number, data: any) {
      const { response, error } = await putRequest<Notification>(
        `notifications/${notificationId}`,
        data,
      );
      if (!error) {
        const index = this.notifications.findIndex(
          (n) => n.id === notificationId,
        );
        if (index !== -1) {
          this.notifications[index] = response.data;
        }
      }
    },
    async bulkReadNotifications(data: { all?: boolean; ids?: number[] }) {
      const { error } = await putRequest<{ updated: number }>(
        "notifications/read",
        data,
      );
      if (!error) {
        this.notifications = this.notifications.map((n) =>
          data.all || data.ids?.includes(n.id)
            ? { ...n, status: NotificationStatus.Read }
            : n,
        );
      }
      return { error };
    },
    resetDateRange() {
      this.from = formatDate(subtractDays(new Date(), 1));
      this.to = formatDate(new Date());
    },
  },
  getters: {
    allNotifications: (state) => state.notifications,
    isLoading: (state) => state.loading,
  },
});
